export default function Select({
  label,
  options,
  id,
  onChange,
  value,
  valueFn = (x) => x,
  disabled,
}) {
  return (
    <>
      <div style={{ flex: 1, opacity: disabled ? 0.5 : 1 }}>
        <label htmlFor={id}>{label}</label>
        <select
          id={id}
          onChange={(e) =>
            onChange(options.find((option) => valueFn(option).toString() === e.target.value))
          }
          value={valueFn(value)}
          disabled={disabled}
        >
          {options.map((option) => (
            <option key={valueFn(option)}>{valueFn(option)}</option>
          ))}
        </select>
      </div>
    </>
  );
}
